import dayjs from "dayjs";
import { ubFormat } from "./ub-time";

const DAY = "YYYY-MM-DD";

/**
 * Статементийн хугацааг Улаанбаатарын огноо болгоно.
 *
 * Instant (`…T16:00:00Z`) ирвэл UB руу хөрвүүлнэ. `period_from/to` нь DATEONLY тул ихэвчлэн
 * «YYYY-MM-DD» ирдэг; хуучин мөрүүд UB-ийн сарын 1-ийг UTC огноогоор (өмнөх өдөр) хадгалсан —
 * from нь сарын 1 биш ч маргааш нь 1 бол хоёр талыг +1 хоногоор залруулна.
 */
export function ubPeriod(from?: string | null, to?: string | null): { from: string; to: string } | null {
  if (!from || !to) return null;
  const isInstant = (v: string) => v.includes("T");
  if (isInstant(from) || isInstant(to)) {
    return { from: ubFormat(from, DAY), to: ubFormat(to, DAY) };
  }
  const f = dayjs(from);
  const e = dayjs(to);
  if (!f.isValid() || !e.isValid()) return null;
  const shifted = f.date() !== 1 && f.add(1, "day").date() === 1;
  return shifted
    ? { from: f.add(1, "day").format(DAY), to: e.add(1, "day").format(DAY) }
    : { from: f.format(DAY), to: e.format(DAY) };
}

/** Бүтэн UB сар бол «2026-08», бусад үед «MM-DD — MM-DD». */
export function formatPeriod(from?: string | null, to?: string | null): string {
  const p = ubPeriod(from, to);
  if (!p) return "-";
  const f = dayjs(p.from);
  const e = dayjs(p.to);
  if (f.date() === 1 && e.isSame(f.endOf("month"), "day")) return f.format("YYYY-MM");
  return `${f.format("MM-DD")} - ${e.format("MM-DD")}`;
}
